import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import * as Contact from '@/components/svgr/contact'
import { ContactAddress } from '@/constants/manifast'
import useMediaQuery from '@/hooks/useMediaQuery'
import { cn } from '@/lib/utils'

import { Flex, Grid } from '../common/Box'
import { BeautyButton, Button } from '../common/Button'
import { ProDialog } from '../common/Dialog'
import { Text } from '../common/Text'
import { Contract as ContractIcon } from '../svgr/common'
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip'

const Contacts: React.FC = () => {
  const { gtLG } = useMediaQuery()
  const { t } = useTranslation()

  const contacts = useMemo(
    () => [
      {
        name: 'X',
        icon: Contact.Twitter,
        href: ContactAddress.Twitter,
        h5Icon: Contact.TwitterH5
      },
      {
        name: 'Telegram',
        icon: Contact.Telegram,
        href: ContactAddress.Telegram,
        h5Icon: Contact.TelegramH5
      },
      {
        name: 'Gitbook',
        icon: Contact.Gitbook,
        href: ContactAddress.Gitbook,
        tooltip: t('contacts.gitbook.howItWorks'),
        h5Icon: Contact.GitbookH5
      },
      {
        name: 'Developer Docs',
        icon: Contact.Dev,
        href: ContactAddress.DevDocs,
        tooltip: t('contacts.developerDocs'),
        h5Icon: Contact.DevH5
      }
    ],
    [t]
  )

  const renderContacts = useCallback(
    () =>
      contacts.map(({ name, href, tooltip, icon: Icon }) => {
        const link = (
          <NavLink
            key={name}
            to={href}
            target="_blank"
            // title={tooltip ? undefined : 'how it works - gitbook'}
          >
            <Icon className="size-8 lg:size-6" />
          </NavLink>
        )
        if (!tooltip) return link

        return (
          <Tooltip key={name}>
            <TooltipTrigger>{link}</TooltipTrigger>
            <TooltipContent className="rounded-md border bg-secondary p-1 text-xs">
              {tooltip}
            </TooltipContent>
          </Tooltip>
        )
      }),
    [contacts]
  )
  if (gtLG)
    return (
      <Flex className="justify-center gap-16 py-4 lg:justify-start lg:gap-2 lg:py-0">
        {renderContacts()}
      </Flex>
    )

  return (
    <ProDialog
      title={t('create.socialsLabel')}
      triggerProps={{
        children: (
          <BeautyButton beauty={false}>
            <ContractIcon />
          </BeautyButton>
        )
      }}
      contentProps={{
        className: 'w-[80vw] max-w-[340px]'
      }}
    >
      <Grid className="grid-cols-2 gap-3">
        {contacts.map(({ name, href, h5Icon: Icon }) => (
          <Button
            variant="secondary"
            key={name}
            className="aspect-square h-auto flex-col"
            onClick={() => {
              window.open(href, '_blank')
            }}
          >
            <Icon className="!size-10" />
            <Text>{name}</Text>
          </Button>
        ))}
      </Grid>
    </ProDialog>
  )
}

export default Contacts
